import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
} from '@material-ui/core';
import parkingTypes, { STANDARD, USER } from 'constants/parkingTypes'
import { GateManagersPicker, ManagersPicker, } from 'components'
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  alert: {
    marginBottom: theme.spacing(3)
  },
  formGroup: {
    marginBottom: theme.spacing(3)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  flexGrow: {
    flexGrow: 1
  },
}));

const ParkingAdmin = props => {
  const { className, parkingInfos, handleFieldChange, ownerEmail, handleOwnerEmailChange, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Admin Only" />
      <CardContent>
        <div className={classes.formGroup}>
          <TextField
            className={classes.field}
            fullWidth
            label="Type"
            margin="dense"
            name="type"
            onChange={event =>
              handleFieldChange(
                event,
                'type',
                Number(event.target.value)
              )
            }
            select
            // eslint-disable-next-line react/jsx-sort-props
            SelectProps={{ native: true }}
            value={parkingInfos.type}
            variant="outlined"
            required
          >
            <option
              disabled
              value=""
            />
            {parkingTypes.map(option => (
              <option
                key={option.id}
                value={option.id}
                label={option.name}
              >
                {option.name}
              </option>
            ))}
          </TextField>
        </div>
        {parkingInfos.type === USER && (
          <div className={classes.formGroup}>
            <TextField
              fullWidth
              label="Parking Owner"
              name="ownerEmail"
              onChange={event =>
                handleOwnerEmailChange(event.target.value)
              }
              value={ownerEmail || ''}
              variant="outlined"
              required
            />
          </div>
        )}
        {parkingInfos.type === STANDARD && <ManagersPicker inputName="Managers" managers={parkingInfos.managers} handleManagersChange={(value) => { handleFieldChange(null, 'managers', value) }} handleManagersEmailChange={(value) => { handleFieldChange(null, 'managersEmail', value) }} />}
        {parkingInfos.type === STANDARD && <GateManagersPicker inputName="Gate Managers" gateManagers={parkingInfos.gateManagers} handleGateManagersChange={(value) => { handleFieldChange(null, 'gateManagers', value) }} />}
        <div className={classes.formGroup}>
          <TextField
            className={classes.field}
            fullWidth
            label="Can set Ad"
            margin="dense"
            name="canSetAd"
            onChange={event => handleFieldChange(event, 'canSetAd', event.target.value)}
            select
            // eslint-disable-next-line react/jsx-sort-props
            SelectProps={{ native: true }}
            value={parkingInfos.canSetAd}
            variant="outlined"
          >
            <option disabled value=""/>
            <option value={true} label="Yes"></option>
            <option value={false} label="No"></option>
          </TextField>
        </div>
      </CardContent>
    </Card>
  );
};

ParkingAdmin.propTypes = {
  parkingInfos: PropTypes.object,
  handleFieldChange: PropTypes.func,
  className: PropTypes.string,
  ownerEmail: PropTypes.string,
  handleOwnerEmailChange: PropTypes.func,
};

export default ParkingAdmin;
